module.exports = __webpack_public_path__ + "media/images/front/products/versana/index-banner-a1650ae3b2d40b7a301c98600d2adcdd.jpg";